export default {
  'aiSkillGroup.title': 'Manage Skill Groups',

  'aiSkillGroup.import.title': 'Import Skill Group',
  'aiSkillGroup.import.provider': 'Source',
  'aiSkillGroup.import.sourceUrl': 'Repository URL',
  'aiSkillGroup.import.sourcePath': 'Folder inside the ZIP (optional)',
  'aiSkillGroup.import.preview': 'Preview',
  'aiSkillGroup.import.preview.title': 'Group import preview',
  'aiSkillGroup.import.confirm': 'Confirm import',
  'aiSkillGroup.import.namePlaceholder': 'Group name (you can edit before confirming)',
  'aiSkillGroup.import.descriptionPlaceholder': 'Group description (optional)',
  'aiSkillGroup.import.allowOverride.label': 'Conflicts',
  'aiSkillGroup.import.allowOverride': 'Allow reassigning skills already in other groups',
  'aiSkillGroup.import.allowOverride.hint':
    'If a skill already belongs to another group, it will be moved into this group instead of raising a conflict.',
  'aiSkillGroup.import.summary':
    'Total: {total} · New: {news} · Existing: {existing} · Conflicts: {conflicts} · Invalid: {invalid}',
  'aiSkillGroup.import.empty': 'The source does not contain detectable skills.',
  'aiSkillGroup.import.column.status': 'Status',
  'aiSkillGroup.import.column.notes': 'Notes',
  'aiSkillGroup.import.status.new': 'New',
  'aiSkillGroup.import.status.alreadyExists': 'Already exists',
  'aiSkillGroup.import.status.conflict': 'Conflict',
  'aiSkillGroup.import.status.invalid': 'Invalid',
  'aiSkillGroup.import.status.imported': 'Imported',
  'aiSkillGroup.import.status.skipped': 'Skipped',
  'aiSkillGroup.import.status.failed': 'Failed',
};
